const parseFeedback = (feedback) => {
  if (!feedback) return null;
  
  if (typeof feedback === 'string') {
    try {
      return JSON.parse(feedback);
    } catch {
      return { assessment: feedback };
    }
  }
  
  return feedback;
};

const formatLearningPoints = (feedback) => {
  if (!feedback) return '';
  
  const learningContent =
    (typeof feedback.learning === 'string' && feedback.learning.trim()) ||
    (typeof feedback.summary === 'string' && feedback.summary.trim()) ||
    (typeof feedback.assessment === 'string' && feedback.assessment.trim()) ||
    (typeof feedback.overall_assessment === 'string' && feedback.overall_assessment.trim()) ||
    '';
  
  if (!learningContent) {
    return '';
  }
  
  const timestamp = new Date().toLocaleString();
  return `# Learning\n*Generated on ${timestamp}*\n\n${learningContent}`;
};

export const addLearningPointsToNotes = (feedback, problemId, problemType = 'LLD') => {
  if (!feedback || !problemId) {
    return;
  }
  
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  
  try {
    const parsedFeedback = parseFeedback(feedback);
    const learningPoints = formatLearningPoints(parsedFeedback);
    
    if (!learningPoints) {
      return;
    }
    
    const typeKey = (problemType || 'LLD').toLowerCase();
    const learningPointsKey = `${typeKey}-learning-points-${problemId}`;
    const notesKey = `${typeKey}-notes-${problemId}`;
    
    const existingPoints = localStorage.getItem(learningPointsKey) || '';
    const updatedPoints = existingPoints
      ? `${existingPoints}\n\n---\n\n${learningPoints}`
      : learningPoints;
    
    localStorage.setItem(learningPointsKey, updatedPoints);
    
    const existingNotes = localStorage.getItem(notesKey) || '';
    const updatedNotes = existingNotes
      ? `${existingNotes}\n\n---\n\n${learningPoints}`
      : learningPoints;
    
    localStorage.setItem(notesKey, updatedNotes);
    
    window.dispatchEvent(
      new CustomEvent('learningPointsAdded', {
        detail: { problemId, problemType }
      })
    );
  } catch (error) {
    console.error('Failed to add learning points to notes:', error);
  }
};

export const generateLearningPointsMarkdown = (feedback) => {
  const parsedFeedback = parseFeedback(feedback);
  return formatLearningPoints(parsedFeedback);
};

